export default "__VITE_ASSET__BHfuSGeo__"